module.exports = __webpack_public_path__ + "img/two2.82cf4032.png";